import React from 'react';

const NoticeUpdateHeader = ({ onPreview, onClose }) => {
  return (
    <div className="md:flex md:justify-between fixed w-full items-center bg-[#1C1C1C] text-txtclr md:px-10 px-5 py-6">
      <div className="md:text-[22px] text-[16px]">
        <h2>[You can fill, upload and attach additional document in our formatted document.]</h2>
      </div>
      <div className="flex md:justify-end justify-between mt-3 md:mt-0 gap-3">
        <button
          type="button"
          onClick={onPreview}
          className="text-center bg-[#307DFF] hover:bg-btnhover text-txtclr text-[18px] py-3 md:px-10 px-14 rounded-md focus:outline-none focus:shadow-outline"
        >
          Preview
        </button>
        <button
          type="submit"
          onClick={onClose}
          className="text-[25px] px-5 text-black bg-txtclr rounded-md"
        >
          X
        </button>
      </div>
    </div>
  );
};

export default NoticeUpdateHeader;
